import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TaxonomyStoreEffects } from './taxonomy-store.effects';
import { reducer } from './taxonomy-store.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('taxonomy', reducer),
    EffectsModule.forFeature([TaxonomyStoreEffects]),
  ],
  providers: [TaxonomyStoreEffects],
})
export class TaxonomyStoreModule {}
